import { createStyles, makeStyles } from "@material-ui/core";

const classicThemeStyle = makeStyles(() =>
  createStyles({
    "@global": {
      body: {
        background: "#F0F2F6",
        color: "#202f43",
      },
    },
  })
);

export default classicThemeStyle;
